import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';
export function createCollapseListAtoms() {
  const singleOpenModeAtom = atom(true);

  // store a Set setter when the list is in controlled mode
  const controlledCallbacksAtom = atom(undefined);

  // the current open-item set for this list instance
  const currentOpenItemsAtom = atom(new Set());

  // write-only atom that toggles an item
  const toggleItemAtom = atom(null, (get, set, id) => {
    var _get;
    const onControlledChange = (_get = get(controlledCallbacksAtom)) == null ? void 0 : _get.setOpenItems;
    const controlled = Boolean(onControlledChange);
    const singleMode = get(singleOpenModeAtom);
    const curr = get(currentOpenItemsAtom);
    const next = new Set(curr);
    if (singleMode) {
      if (next.has(id)) {
        next.clear();
      } else {
        next.clear();
        next.add(id);
      }
    } else {
      next.has(id) ? next.delete(id) : next.add(id);
    }
    controlled ? onControlledChange == null ? void 0 : onControlledChange(next) : set(currentOpenItemsAtom, next);
  });
  const isItemOpenAtom = atomFamily(id => atom(get => get(currentOpenItemsAtom).has(id)));
  return {
    controlledCallbacksAtom,
    currentOpenItemsAtom,
    isItemOpenAtom,
    singleOpenModeAtom,
    toggleItemAtom
  };
}
//# sourceMappingURL=create-collapse-list-atoms.js.map